<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/contacts"><UserGroupIcon class="mr-2 w-8 h-8" /> អតិថិជន</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span>
      {{ form.first_name }} {{ form.last_name }}
    </h1>
    <trashed-message v-if="contact.deleted_at" class="mb-6" @restore="restore"> អតិថិជននេះត្រូវបានលុប! </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.customer_id" :error="form.errors.customer_id" class="pb-8 pr-6 w-full lg:w-1/2" label="ID អតិថិជន *" />
          <div class="lg:w-1/2"></div>
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="នាមត្រកូល *" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="នាមខ្លួន *" />
          <select-input v-model="form.gender" :error="form.errors.gender" class="pb-8 pr-6 w-full lg:w-1/2" label="ភេទ">
            <option :value="null">ជ្រើសរើស</option>
            <option value="ប្រុស">ប្រុស</option>
            <option value="ស្រី">ស្រី</option>
          </select-input>
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="លេខទូរសព្ទ" />
          <!-- <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="អ៊ីមែល" /> -->
          <div class="relative pr-6 w-full lg:w-1/2">
            <textarea-input @keydown="handleAddress($event)" autocomplete="on" v-model="form.address" :error="form.errors.address" class="w-full" label="អាសយដ្ឋាន" />
            <div v-if="this.suggested_address.length > 0" style="position: absolute; z-index: 100" class="autocomplete-dropdown absolute z-10 -mt-10 w-full bg-white border rounded shadow-lg">
              <div v-for="suggest in this.suggested_address" :key="suggest.address" class="p-2 text-indigo-600 hover:bg-gray-100 cursor-pointer" @click="setAddress(suggest.address)">{{ suggest.address }}</div>
            </div>
          </div>
          <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="ខេត្ត/ក្រុង" /> -->
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!contact.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">លុបចេញ</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">រក្សាទុក</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { UserGroupIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
    UserGroupIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  props: {
    contact: Object,
  },
  remember: 'form',
  data() {
    return {
      suggested_address: [],
      form: this.$inertia.form({
        customer_id: this.contact.customer_id,
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        gender: this.contact.gender,
        email: this.contact.email,
        phone: this.contact.phone,
        address: this.contact.address,
        city: this.contact.city,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/contacts/${this.contact.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this contact?')) {
        this.$inertia.delete(`/contacts/${this.contact.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this contact?')) {
        this.$inertia.put(`/contacts/${this.contact.id}/restore`)
      }
    },
    handleAddress(e) {
      this.suggested_address = []
      if (e.target.value.length > 2) {
        axios
          .get('/loans/find_address', {
            params: {
              address: e.target.value,
            },
          })
          .then((response) => {
            this.suggested_address = []
            if (Object.keys(response.data).length !== 0) {
              this.suggested_address = response.data
            }
          })
      }
    },
    setAddress(add) {
      this.form.address = add
      this.suggested_address = []
    },
  },
}
</script>
